import { FORM_ERROR, GENERIC_ERROR } from '~/constants/automationRuleForm';

type JSONAutomationRuleError = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  status: number;
};

type AutomationRuleError = {
  hasRequiredNameNetworkError?: boolean;
  hasRequiredParcelTemplateNetworkError?: boolean;
  hasSenderAddressRuleNetworkError?: boolean;
  hasServiceLevelRuleNetworkError?: boolean;
  kind?: string;
  message?: string;
};

const EMPTY_RULE_ERROR = {
  hasRequiredNameNetworkError: false,
  hasRequiredParcelTemplateNetworkError: false,
  hasSenderAddressRuleNetworkError: false,
  hasServiceLevelRuleNetworkError: false,
  kind: '',
  message: '',
};

const fromJSON = (jsonAutomationRuleError: JSONAutomationRuleError): AutomationRuleError => {
  const { data = {}, status: responseStatus } = jsonAutomationRuleError;
  let error = {
    hasRequiredNameNetworkError: false,
    hasRequiredParcelTemplateNetworkError: false,
    hasSenderAddressRuleNetworkError: false,
    hasServiceLevelRuleNetworkError: false,
    kind: '',
    message: '',
  };

  switch (responseStatus) {
    case 400:
      // code block
      error.message = '';
      error.kind = FORM_ERROR;

      Object.keys(data).forEach((key) => {
        const errorData = data[key];
        // if a required field is missing the backend
        // provides a message string in an array
        const dataIsArray = Array.isArray(errorData);

        // if error key is detail treat it like a generic error
        if (key === 'detail') {
          error.message = errorData;
        } else if (dataIsArray) {
          const message = errorData[0];
          if (message === 'Field is required') {
            if (key === 'name') error.hasRequiredNameNetworkError = true;

            if (key === 'parcel_template_object_id')
              error.hasRequiredParcelTemplateNetworkError = true;
          } else if (key === 'service_level_token' || key === 'account_object_id') {
            error.hasServiceLevelRuleNetworkError = true;
          } else if (key === 'sender_address_id') {
            error.hasSenderAddressRuleNetworkError = true;
          }
        }
      });

      break;

    default:
      error = {
        hasRequiredNameNetworkError: false,
        hasRequiredParcelTemplateNetworkError: false,
        hasSenderAddressRuleNetworkError: false,
        hasServiceLevelRuleNetworkError: false,
        kind: GENERIC_ERROR,
        message: 'Something went wrong on our end. Please try again or contact us for assistance.',
      };
  }

  return error;
};

export { AutomationRuleError, EMPTY_RULE_ERROR, fromJSON };
